module.exports = __webpack_public_path__ + "static/img/saba.f7b0f4b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/saba.webp
// module id = g5lT
// module chunks = 0